
import axiosServices from './request';

const ReaderCenter = axiosServices('readercenter');

export default {
  /** 授权 **/
  //通过openid和officialAccountsId获取基本信息
  getUserInfoByOpenId: ReaderCenter('get', 'wechatUser/getUserInfoByOpenId'),
  //通过Cookie获取用户信息
  getUserInfo: ReaderCenter('get', 'wechatUser/getUserInfoForClient'),
  //获取记录的地理位置
  getLocationRecord: ReaderCenter('get', 'appReader/getLocationRecord'),

  /** 获取当前用户关联的手机号码 */
  getUserPhoneNumber: ReaderCenter('get', 'wechatUser/getUserPhoneNumber'),

  //关联公众号
  /**
   * operateOfficialAccountsId     23公众号id
   * operateWechatUserId           23公众号用户id
   * otherOfficialAccountsId      其他公众号id
   * otherWechatUserId            其他公众号用户id
   */
  associateOfficialAccounts: ReaderCenter('post', 'operateUserMerge/insert'),

  //更新用户手机号（绑定）
  updateUserByOpenId: ReaderCenter('post', 'wechatUser/updateUserByOpenId'),
  // 查询用户标签
  getUserGradeLabel: ReaderCenter('get', 'userGradeLabel/getUserGradeLabel'),
  // 获取用户书币数量
  getMoneyCount: ReaderCenter('get', 'rmallBookMoney/getMoneyCount'),
  // 通过微信用户的userId获取用户扩展信息
  getWechatUserExtendInfo: ReaderCenter('get', 'wechatUser/getWechatUserExtendInfo'),
  /** 个人中心获取成就数量 */
  getUserAchievementInfo: ReaderCenter('get', 'achievement/getUserAchievementInfo'),
  // 获取用户信息
  getWechatUserById: ReaderCenter('get', 'wechatUser/getWechatUserById'),

  /** 客户端获取商品列表 */
  getList4Wechat: ReaderCenter('get', 'rmallGoods/getList4Wechat'),

  addServiceRecord: ReaderCenter('post', 'wechatUser/addServiceRecord'),
  /** 所有年级标签 */
  getAllUserGradeLabel: ReaderCenter('get', 'userGradeLabel/getAllUserGradeLabel'),
  /** 用户选择标签 */
  addUserGradeLabel: ReaderCenter('get', 'userGradeLabel/addUserGradeLabel'),
  //小程序获取地址列表
  rmallAddressGetList: ReaderCenter('get', 'rmallAddress/getList'),
  /** 保存用户信息 */
  saveWechatUserExtendInfo: ReaderCenter('post', 'wechatUser/saveWechatUserExtendInfo'),
  /** 互助信息列表 */
  getAllQuestionList: ReaderCenter('get', 'appletQuestion/getLatestQuestionList'),
  /** 获取用户小睿标签 */
  getRaysLabelByUser: ReaderCenter('get', 'userRaysLabel/getRaysLabelByUser'),
  /** 设置用户小睿标签 */
  addUserBaseRaysLabel: ReaderCenter('post', 'userRaysLabel/addUserBaseRaysLabel'),
  /** 删除用户小睿标签 */
  deleteAllLabelByUser: ReaderCenter('get', 'userRaysLabel/deleteAllLabelByUser'),
  /** 获取身份标签  */
  getUserBaseRaysLabel: ReaderCenter('get', 'userRaysLabel/getUserBaseRaysLabel'),
  /**H5待领取书币数量 */
  getUserWaitMoney: ReaderCenter('get', 'rmallBookMoneyRecord/getUserWaitMoney'),

  /** 跳转前埋点 - 用户绑定 */
  toBindInsert: ReaderCenter('post', 'userJumpRecord/insert'),

  //根据手机号授权
  phoneAuthorizeUser: ReaderCenter('post', 'reader/author'),
  /** 通过用户id获取实名认证状态 */
  getByUserId: ReaderCenter('get', 'realnameCredentials/getByUserId'),
  /** 实名认证 */
  insertCredential: ReaderCenter('post', 'realnameCredentials/insert'),
  /** 更新用户头像和昵称 */
  updateUserBaseInfo: ReaderCenter('post', 'wechatUser/updateUserBaseInfo'),
  /** 根据成就类型判断当前用户是否获取了当前成就 */
  checkAchievement: ReaderCenter('get', 'achievement/checkAchievement'),
  //获取学霸认证信息
  getStudentInfo: ReaderCenter('get', 'appletStudyOverlord/getStudyOverlordInfo'),

  // 新增性别勋章
  addSexAchievement: ReaderCenter('get', 'achievement/addSexAchievement'),

  // 获取关联用户性别
  getRelateUserSex: ReaderCenter('get', 'wechatUser/getRelateUserSex'),

  /** 合并公众号用户 */
  miniGzhUserRelate: ReaderCenter('post', 'miniGzhUserRelate/insert'),
  // 用户合并
  mergeGzhUser: ReaderCenter('post', 'raysUnionUser/mergeGzhUser')
};

